import { Image, IStore, PriceRange, StoreOpenCloseTime } from 'AppTypes'

export class Store implements IStore {
  id: string

  storeName: string

  branchName?: string

  furigana?: string

  aliases?: string

  province?: string

  address?: string

  buildingName?: string

  images?: Image[]

  location?: string

  priceRange?: PriceRange[]

  directguide?: string

  introduce?: string

  phonenumber?: string

  preventionDisease?: string

  timeOpen?: StoreOpenCloseTime

  timeClose?: StoreOpenCloseTime

  workingDays?: string[]

  dayOff?: string

  smoking?: string

  parkingLot?: string

  webSNS?: string

  constructor (store: IStore) {
    this.id = store.id
    this.storeName = store.storeName
    this.branchName = store.branchName
    this.furigana = store.furigana
    this.aliases = store.aliases
    this.province = store.province
    this.address = store.address
    this.buildingName = store.buildingName
    this.images = store.images
    this.location = store.location
    this.priceRange = store.priceRange
    this.directguide = store.directguide
    this.introduce = store.introduce
    this.phonenumber = store.phonenumber
    this.preventionDisease = store.preventionDisease
    this.timeOpen = store.timeOpen
    this.timeClose = store.timeClose
    this.workingDays = store.workingDays
    this.dayOff = store.dayOff
    this.smoking = store.smoking
    this.parkingLot = store.parkingLot
    this.webSNS = store.webSNS
  }
}
